<div class="main-container">
  <div class="app-containerv2">
    <router-outlet></router-outlet>
  </div>
</div>
